import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

        gsap.delayedCall(0.1, () => {
            this.$points = this.$('points');
            this.$bailaLetters = this.$('bailaLabel')[0].querySelectorAll('.char-wrap');

            this.timeline = new gsap.timeline({repeat: -1});

            this.timeline.fromTo(this.$bailaLetters,1,{
                alpha: 0,
            }, {
                alpha: 1,
                stagger: {
                    from: "left",
                    axis: "x",
                    amount: 0.7
                }
            });

            this.timeline.fromTo(this.$points,1,{
                scale: 0,
                y: "30px"
            }, {
                scale: 1,
                y: 0,
                stagger: {
                    from: "center",
                    axis: "x",
                    amount: 0.15
                }
            }, "-=1.5");

            this.timeline.pause();
        });
    }

    progress({progress, isReversed}) {
        let relativeProgress = progress;
        if(isReversed) relativeProgress = 1-progress;
        
        if(this.timeline != undefined) {
            this.timeline.progress(relativeProgress);
        }
    }
}
